/*LIBRARY*/
import { connect } from "react-redux";

/*DATA*/
import dict from "../../Data/dict.json";

/*COMPONENT*/
import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
// import dict from "../../Data/dict.json";

/*CONST*/

const SET_TL = ({
  //variable
  auth,
  layer,
  properties,

  //function
  set_value_properties,
}) => {
  //localStorage
  const language = localStorage?.language || auth?.language;

  //state & ref

  //global props
  const { field_editable } = properties;
  const { geo_layer_list, layer_id } = layer;

  //variables
  const geo_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;
  const fields = geo_layer?.fields || [];

  //functions

  // console.log("field_editable=", field_editable);
  // console.log("fields=", fields);

  return (
    <main>
      <h1 className="text_bold margin_bottom">Pengaturan Template Literal</h1>

      <div className="paddingTop_10">
        <label htmlFor="first_text" className="font_18">
          {dict["Prefix Text"][language]}
        </label>
        <input
          id="first_text"
          type="text"
          value={field_editable?.template_literal_text?.first}
          onChange={(e) => {
            const value = e.target.value;
            set_value_properties({
              key: "field_editable",
              value: {
                ...field_editable,
                template_literal_text: {
                  ...field_editable.template_literal_text,
                  first: value,
                },
              },
            });
          }}
        />
      </div>

      <div className="paddingTop_10">
        <label htmlFor="last_text" className="font_18">
          {dict["Suffix Text"][language]}
        </label>
        <input
          id="last_text"
          type="text"
          value={field_editable?.template_literal_text?.last}
          onChange={(e) => {
            const value = e.target.value;
            set_value_properties({
              key: "field_editable",
              value: {
                ...field_editable,
                template_literal_text: {
                  ...field_editable.template_literal_text,
                  last: value,
                },
              },
            });
          }}
        />
      </div>

      <div className="paddingTop_10">
        <label htmlFor="refer_to_column" className="font_18">
          {dict["Refer to"][language]}
        </label>
        <Dropdown
          placeholder="Pilih"
          filter_on
          is_enable_empty={false}
          value={field_editable.reference_key}
          onChange={(value) => {
            console.log(value);
            set_value_properties({
              key: "field_editable",
              value: {
                ...field_editable,
                reference_key: value,
              },
            });
          }}
        >
          {fields
            ?.filter((item) => item?.uuid !== field_editable?.uuid)
            ?.map((item, idx) => {
              return (
                <option key={item?.key} value={item?.key} id={idx}>
                  {item?.name}
                </option>
              );
            })}
        </Dropdown>
      </div>

      <div className="input_note paddingTop_10">
        {
          dict[
            "Format: prefix text + (value of the referenced column) + suffix text"
          ][language]
        }
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_TL);
